// Lightweight, ad-ready analytics. No-ops safely until you add IDs to frontend/.env:
//   REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXX   (Google Analytics 4 / Google Ads)
//   REACT_APP_FB_PIXEL_ID=XXXXXXXXXX        (Meta / Facebook Pixel)

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  // Google Analytics / Google Ads
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }

  // Meta / Facebook Pixel
  if (FB_PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", FB_PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("trackCustom", name, params);
}

// Fire a standard "Lead" conversion (used by ad platforms for optimization).
export function trackLead(params = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", "generate_lead", params);
  if (window.fbq) window.fbq("track", "Lead", params);
}

export const analyticsEnabled = Boolean(GA_ID || FB_PIXEL_ID);
